<div class="d-flex flex-row flex-wrap product-detail justify-content-start align-items-end align-items-lg-start">
  <div class="flex-50 d-none d-lg-flex flex-row flex-wrap justify-content-center">
    <div class="flex-90">
      <app-product-swiper #productSwiper [product]="currentProduct" [startingSlide]="1"></app-product-swiper>
    </div>
  </div>
  <div class="flex-100 flex-lg-50 pl-md-4 pr-md-4">
    <h1 [@fadeInLeft]>{{currentProduct?.name}}</h1>
    <div class="d-flex flex-row flex-wrap product-buy">
      <div *ngIf="currentProduct?.oldPrice && !currentProduct?.adjustedPrice" class="old-price text-muted">
        <span>{{currentProduct?.oldPriceDisplay}}</span>
      </div>
      <div *ngIf="!currentProduct?.adjustedPrice" class="new-price">{{currentProduct?.newPriceDisplay}}</div>
      <div *ngIf="currentProduct?.adjustedPrice" class="new-price">{{currentProduct?.adjustedPriceDisplay}}</div>
      <div class="flex-100 d-none d-lg-flex">
        <app-controls-detail #controlsDetail *ngIf="currentProduct" [product]="currentProduct" [listId]="currentCategory?.seName"></app-controls-detail>
      </div>
      <div class="flex-100 d-flex flex-row flex-wrap">
        <div class="flex-100 mb-2" *ngIf="!currentProduct?.adjustedPrice && currentProduct?.newPrice && afterpayLimits && currentProduct?.newPrice > afterpayLimits.min && afterpayLimits.max > currentProduct?.newPrice">
          <span class="afterpay">4 interest free payments of <strong>{{currentProduct?.installmentPriceDisplay}}</strong> with
            <a (click)=openAfterpay()>
              <img src="assets/images/payments/logos/ap-logo-152x31.png" alt="Pay with Afterpay" />
            </a>
          </span>
        </div>
        <div class="flex-100 mb-2" *ngIf="currentProduct?.adjustedPrice && afterpayLimits && currentProduct?.adjustedPrice > afterpayLimits.min && afterpayLimits.max > currentProduct?.adjustedPrice">
          <span class="afterpay">4 interest free payments of <strong>{{currentProduct?.adjustedInstallmentPriceDisplay}}</strong> with
            <a (click)=openAfterpay()>
              <img src="assets/images/payments/logos/ap-logo-152x31.png" alt="Pay with Afterpay" />
            </a>
          </span>
        </div>
        <div class="flex-100 mb-2 d-flex flex-row flex-wrap">
          <div class="flex-auto pt-1" (click)="scrollReviews()">
            <app-rating #rating [product]="currentProduct" [direction]="'row'" [showNumber]="true" [showViewLink]="true"></app-rating>
          </div>
        </div>
        <div class="flex-100 flex-fill py-1" *ngIf="currentProduct?.discounts && currentProduct?.discounts.length > 0">
          <span>This product has the follows discounts:</span>
          <ul>
            <li *ngFor="let discount of currentProduct?.discounts">{{discount.name}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex-100 d-lg-none d-flex flex-row flex-wrap">
      <div class="flex-100">
        <app-controls-detail #controlsDetail *ngIf="currentProduct" [product]="currentProduct" [listId]="currentCategory?.seName"></app-controls-detail>
      </div>
    </div>
    <div [class]="expandedText? 'short-description d-lg-none description-block' : 'short-description short-description-collapsed d-lg-none description-block'">
      <div [innerHtml]="currentProduct.shortDescription | safeHtml" class="mt-2 mb-2 long-description"></div>
      <div [innerHtml]="currentProduct.fullDescription | safeHtml" class="mt-2 mb-2 long-description"></div>
      <div *ngIf="needsExpand" class="expand-button">
        <button mat-button color="accent" (click)="expandedText=!expandedText"><span class="fw-600">{{expandedText? 'Less' : 'Read More'  }}&nbsp;&gt;</span></button>
      </div>
    </div>
    <div class="d-none d-lg-block description-block">
      <div [innerHtml]="currentProduct.shortDescription | safeHtml" class="mt-2 mb-2 long-description"></div>
      <div [innerHtml]="currentProduct.fullDescription | safeHtml" class="mt-2 mb-2 long-description"></div>
    </div>
  </div>
  <div class="flex-100 d-lg-none">
    <app-product-swiper #productSwiper [product]="currentProduct" [startingSlide]="1"></app-product-swiper>
  </div>
</div>
<div class="d-none d-lg-flex flex-row flex-wrap mt-2" id="productTabs">
  <div class="flex-100 flex-fill product-tabs">
    <mat-tab-group mat-align-tabs="center" mat-stretch-tabs="false" [@.disabled]="true" [selectedIndex]="tabIndex">
      <mat-tab *ngFor="let tab of currentProduct.tabs" [label]="tab.displayName">
        <div class="product-tab-content" [innerHtml]="tab.description | safeHtml"></div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<div class="d-lg-none mt-2 products-accordion" id="productAccordion">
  <mat-accordion [displayMode]="'flat'" [multi]="true">
    <mat-expansion-panel *ngFor="let tab of currentProduct.tabs;">
      <mat-expansion-panel-header class="d-flex flex-row flex-wrap">
        <mat-panel-title>
          <div class="flex-90 h4">{{tab.displayName}}</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="product-tab-mobile-content" [innerHtml]="tab.description | safeHtml"></div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
